module.exports = __webpack_public_path__ + "images/avecobc30e99487a10b540c462c1e525fdac0.png";